import 'firebase/auth';

import firebase from 'firebase/app';


const config = {
    apiKey: process.env.VUE_APP_FB_API_KEY,
    authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FB_DB_URL,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FB_STORAGE_BKT,
};
firebase.initializeApp(config);

const appAuth = firebase.auth();
//appAuth.useEmulator('http://localhost:9099');

export default appAuth;